/* ============================================================
   REGINA – Produkt-Hero
   assets/section-product-hero.js
   ------------------------------------------------------------
   - Variantenwahl (Pills) findet die passende Variante clientseitig
   - Preis, Bild und Kaufen-Button aktualisieren sich live
   - Mengenregler (+/-)
   - Galerie: Thumbnails wechseln das Hauptbild
   - Add-to-Cart per AJAX (/cart/add.js), ohne Seiten-Reload;
     das <form> bleibt ein echtes, funktionierendes Formular als
     Fallback, falls JS aus irgendeinem Grund nicht läuft.
   ============================================================ */
(function () {
  /* ---------- Geld-Formatierung passend zum Shop-Format ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '€{{amount}}';

    function defaultTo(a, b) { return a == null || a === '' ? b : a; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, '.');
      decimal = defaultTo(decimal, ',');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-product-hero]').forEach(function (section) {
      var variantsScript = section.parentElement.querySelector('[data-product-variants]') || document.querySelector('[data-product-variants]');
      var variants = [];
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }

      var moneyFormat = window.__shopMoneyFormat || '€{{amount}}';
      var form = section.querySelector('.p-form');
      var variantInput = section.querySelector('[data-variant-id]');
      var priceWrap = section.querySelector('[data-price]');
      var addBtn = section.querySelector('[data-add-btn]');
      var addLabel = addBtn ? addBtn.querySelector('.p-add-label') : null;
      var feedback = section.querySelector('[data-add-feedback]');
      var optionGroups = Array.prototype.slice.call(section.querySelectorAll('.p-option'));
      var gallery = section.querySelector('[data-gallery]');

      /* ---------- Ausgewählte Optionen aus den aktiven Pills ablesen ---------- */
      var selected = optionGroups.map(function (group) {
        var active = group.querySelector('.p-pill.active');
        return active ? active.dataset.optionValue : null;
      });

      function findVariant(options) {
        return variants.find(function (v) {
          var vOpts = [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
          return vOpts.length === options.length && vOpts.every(function (o, i) { return o === options[i]; });
        });
      }

      function updatePrice(variant) {
        if (!priceWrap) return;
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="p-price-sale">' + formatMoney(variant.price, moneyFormat) + '</span>';
          html += '<span class="p-price-compare">' + formatMoney(variant.compare_at_price, moneyFormat) + '</span>';
        } else {
          html += '<span class="p-price-regular">' + formatMoney(variant.price, moneyFormat) + '</span>';
        }
        // bestehendes Grundpreis-Element (falls vorhanden) unangetastet lassen
        var unit = priceWrap.querySelector('.p-price-unit');
        priceWrap.innerHTML = html;
        if (unit) priceWrap.appendChild(unit);
      }

      function updateImage(variant) {
        if (!gallery || !variant.featured_image) return;
        var id = variant.featured_image.id;
        var slide = gallery.querySelector('.p-gallery-slide[data-image-id="' + id + '"]');
        var thumb = gallery.querySelector('.p-thumb[data-image-id="' + id + '"]');
        if (slide) {
          gallery.querySelectorAll('.p-gallery-slide').forEach(function (s) { s.classList.remove('active'); });
          slide.classList.add('active');
        }
        if (thumb) {
          gallery.querySelectorAll('.p-thumb').forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
        }
      }

      function updateAvailability(variant) {
        if (!addBtn) return;
        var available = variant && variant.available;
        addBtn.disabled = !available;
        if (addLabel) {
          addLabel.textContent = available
            ? (addBtn.dataset.availableLabel || addLabel.dataset.originalLabel || addLabel.textContent)
            : (addBtn.dataset.soldOutLabel || 'Ausverkauft');
        }
      }

      // Ursprüngliche Labels merken (für den Wechsel zurück zu "verfügbar")
      if (addLabel) addLabel.dataset.originalLabel = addLabel.textContent;

      function onOptionChange() {
        var variant = findVariant(selected);
        if (!variant) return; // Kombination existiert nicht -> Zustand einfach beibehalten
        if (variantInput) variantInput.value = variant.id;
        updatePrice(variant);
        updateImage(variant);
        updateAvailability(variant);
        // URL leise aktualisieren (Teilen/Zurück-Button), ohne Seiten-Reload
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      }

      optionGroups.forEach(function (group, idx) {
        group.querySelectorAll('.p-pill').forEach(function (pill) {
          pill.addEventListener('click', function () {
            group.querySelectorAll('.p-pill').forEach(function (p) { p.classList.remove('active'); });
            pill.classList.add('active');
            selected[idx] = pill.dataset.optionValue;
            onOptionChange();
          });
        });
      });

      /* ---------- Galerie: Thumbnails ---------- */
      if (gallery) {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var idx = thumb.dataset.galleryThumb;
            gallery.querySelectorAll('.p-gallery-slide').forEach(function (s) {
              s.classList.toggle('active', s.dataset.gallerySlide === idx);
            });
            gallery.querySelectorAll('.p-thumb').forEach(function (t) { t.classList.remove('active'); });
            thumb.classList.add('active');
          });
        });

        var moreBtn = gallery.querySelector('[data-gallery-more]');
        var thumbsWrap = gallery.querySelector('[data-gallery-thumbs]');
        if (moreBtn && thumbsWrap) {
          moreBtn.addEventListener('click', function () {
            thumbsWrap.classList.add('is-expanded');
          });
        }
      }

      /* ---------- Mengenregler ---------- */
      var qtyInput = section.querySelector('[data-qty-input]');
      var qtyMinus = section.querySelector('[data-qty-minus]');
      var qtyPlus = section.querySelector('[data-qty-plus]');
      if (qtyInput && qtyMinus && qtyPlus) {
        qtyMinus.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          qtyInput.value = v;
        });
        qtyPlus.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
          qtyInput.value = v;
        });
        qtyInput.addEventListener('change', function () {
          var v = parseInt(qtyInput.value, 10);
          if (!v || v < 1) qtyInput.value = 1;
        });
      }

      /* ---------- Add to Cart per AJAX ---------- */
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;

          addBtn.classList.add('is-loading');
          addBtn.classList.remove('is-success', 'is-error');
          if (feedback) feedback.textContent = '';

          var formData = new FormData(form);

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' }
          })
            .then(function (res) {
              return res.json().then(function (data) { return { ok: res.ok, data: data }; });
            })
            .then(function (result) {
              addBtn.classList.remove('is-loading');
              if (result.ok) {
                addBtn.classList.add('is-success');
                if (feedback) feedback.textContent = 'Zum Warenkorb hinzugefügt.';
                // Warenkorb-Icon im Header aktualisieren: den echten,
                // frisch gerenderten HTML-Schnipsel von Shopify holen
                // (statt Dawns verschachtelte Bubble-Struktur selbst
                // nachzubauen) - garantiert immer korrekt, auch wenn
                // sich Dawns Markup künftig ändert.
                fetch(window.location.pathname + '?sections=cart-icon-bubble&_=' + Date.now(), { cache: 'no-store' })
                  .then(function (r) { return r.json(); })
                  .then(function (data) {
                    var html = data['cart-icon-bubble'];
                    if (!html) return;
                    var doc = new DOMParser().parseFromString(html, 'text/html');
                    var fresh = doc.querySelector('.shopify-section') || doc.body;
                    var target = document.getElementById('cart-icon-bubble');
                    if (target && fresh) target.innerHTML = fresh.innerHTML;
                  })
                  .catch(function () {});
                setTimeout(function () { addBtn.classList.remove('is-success'); }, 2200);
              } else {
                addBtn.classList.add('is-error');
                if (feedback) feedback.textContent = result.data.description || 'Das hat leider nicht geklappt. Bitte versuch es erneut.';
                setTimeout(function () { addBtn.classList.remove('is-error'); }, 2600);
              }
            })
            .catch(function () {
              addBtn.classList.remove('is-loading');
              addBtn.classList.add('is-error');
              if (feedback) feedback.textContent = 'Verbindungsfehler. Bitte versuch es erneut.';
              setTimeout(function () { addBtn.classList.remove('is-error'); }, 2600);
            });
        });
      }
      /* ---------- Sticky Kaufleiste ---------- */
      var stickyBar = section.querySelector('[data-sticky-bar]');
      var stickyAddBtn = section.querySelector('[data-sticky-add]');
      var stickyPrice = section.querySelector('[data-sticky-price]');
      var mainAddBtn = addBtn;

      if (stickyBar && 'IntersectionObserver' in window) {
        var target = section.querySelector('.p-buy') || mainAddBtn;
        var io2 = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            stickyBar.classList.toggle('is-visible', !e.isIntersecting);
            stickyBar.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
          });
        }, { threshold: 0 });
        io2.observe(target);
      }

      if (stickyAddBtn && form) {
        stickyAddBtn.addEventListener('click', function () {
          if (mainAddBtn && mainAddBtn.disabled) return;
          // spiegelt den Lade-/Erfolgs-Zustand auf der Sticky-Leiste
          stickyAddBtn.classList.add('is-loading');
          stickyAddBtn.classList.remove('is-success', 'is-error');
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
        // Haupt-Button-Zustände auf die Sticky-Leiste spiegeln
        if (mainAddBtn) {
          var mo = new MutationObserver(function () {
            ['is-loading', 'is-success', 'is-error'].forEach(function (cls) {
              stickyAddBtn.classList.toggle(cls, mainAddBtn.classList.contains(cls));
            });
          });
          mo.observe(mainAddBtn, { attributes: true, attributeFilter: ['class'] });
        }
      }

      // Sticky-Preis mit der Variantenwahl synchron halten
      var originalUpdatePrice = updatePrice;
      updatePrice = function (variant) {
        originalUpdatePrice(variant);
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, moneyFormat);
      };
    });
  });
})();
